import { PartnerConference } from './partnerConferences/partnerConferences.types';

export const conferences: PartnerConference[] = [
  {
    name: 'Friends of Good Software',
    description: 'online from The Netherlands',
    url: 'https://frogsconf.nl',
  },
  {
    name: 'SoCraTes Canaries',
    description: 'Gran Canaria, Spain',
    url: 'https://www.socracan.org',
  },
  {
    name: 'SoCraTes Canada',
    description: 'Selenia Lodge, Québec, Canada',
    url: 'https://socrates-ca.github.io/',
  },
  {
    name: 'SoCraTes Italy',
    description: 'Rimini, Italy',
    url: 'https://www.socrates-conference.it/',
  },
  {
    name: 'SoCraTes UK',
    description: 'Dorking, England',
    url: 'https://socratesuk.org/',
  },
  {
    name: 'JS CraftCamp',
    description: 'Munich, Germany',
    url: 'https://jscraftcamp.org',
  },
  {
    name: 'SoCraTes Day Switzerland',
    description: 'Zurich, Switzerland',
    url: 'https://socrates-day.ch/',
  },
  {
    name: 'SoCraTes Day Franken',
    description: 'Nuremberg, Germany',
    url: 'https://socrates-day-franken.de/',
  },
  {
    name: 'SoCraTes Day Berlin',
    description: 'Berlin, Germany',
    url: 'https://socratesday.berlin',
  },
  {
    name: 'SoCraTes Day MOIN',
    description: 'Hamburg, Germany',
    url: 'https://ti.to/crftd/socratesdaymoin2025',
  },
  {
    name: 'SoCraTes Austria',
    description: 'Linz, Austria',
    url: 'https://socrates-conference.at/',
  },
  {
    name: 'SoCraTes France',
    description: 'Rochegude, France',
    url: 'https://socrates-fr.github.io',
  },
  {
    name: 'SoCraTes Maroc',
    description: 'Bouznica, Morocco',
    url: 'https://socrates-ma.github.io',
  },
  {
    name: 'SoCraTes BE',
    description: 'La Roche-en-Ardenne, Belgium',
    url: 'https://socratesbe.org',
  },
  {
    name: 'SoCraTes Crete',
    description: 'Crete, Greece',
    url: 'https://socrates-crete.org',
  },
  {
    name: 'CodeFreeze',
    description: 'Kiilopää, Finland',
    url: 'https://www.codefreeze.fi/',
  },
  {
    name: 'SoCraTes Conference Switzerland',
    description: 'Ftan, Switzerland',
    url: 'https://socrates-ch.org/',
  },
  {
    name: 'I T.A.K.E. Unconference',
    description: 'Bucharest, Romania',
    url: 'https://itakeunconf.com/',
  },
  {
    name: 'SENECA',
    description: 'Erlangen, Germany',
    url: 'https://seneca.camp/',
  },
  {
    name: 'CITCON',
    description: 'Continuous Integration and Testing Conference',
    url: 'https://citconf.com/',
  },
];
